/* eslint-disable no-console */
import { AxiosError } from 'axios';
import {
  fetchBasicFr,
  fetchCheckAuth,
  fetchClusterDb,
} from 'components/libs/fetch';
import { API_PATHS } from 'constant/api';

import { DATA_SETTING, TABLE_PAGE_INIT, TABLE_PAGE_SIZE } from './constant';

const postLogin = async ({
  body: _body,
}: {
  body: {
    username: string;
    password: string;
  };
}): Promise<boolean> => {
  try {
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(false);
  }
};

const getUser = async (_accessToken?: string): Promise<object> => {
  try {
    return Promise.resolve({ name: 'TARO' });
  } catch (error) {
    return Promise.reject(error);
  }
};

const postAuthLogin = async (header: IHeader) => {
  const api = fetchCheckAuth(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.get(API_PATHS.face_db);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const postSettingDb = async (body: ISettingQuery) => {
  const api = fetchBasicFr({ appId: body.appId, appKey: body.appKey });
  try {
    const { data } = await api.post(
      API_PATHS.setting(body.id, body.clusterDbId),
      { username: body.username, roleType: DATA_SETTING.roleType }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getDatabases = async (body: IGetDatabaseQuery) => {
  const api = fetchBasicFr({ appId: body.appId, appKey: body.appKey });
  const { ...query } = body;

  const searchQuery: Record<string, string> = {
    'pagination[page]': query.page ?? TABLE_PAGE_INIT,
    'pagination[pageSize]': query.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (query.name) searchQuery['filters[name]'] = query.name;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.database(body.id) + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getReferences = async (body: IGetReferencesQuery) => {
  const api = fetchClusterDb(body.appId, body.appKey, body.dbId, body.dbKey);

  const searchQuery: Record<string, string> = {
    page: body.page ?? TABLE_PAGE_INIT,
    take: body.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (body.startTime) searchQuery['filters[startTime]'] = body.startTime;
  if (body.endTime) searchQuery['filters[endTime]'] = body.endTime;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.reference + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getReferenceDetail = async (id: string, header: IHeader) => {
  const api = fetchClusterDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.get(API_PATHS.reference + '/' + id);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateReference = async (id: string, body: IUpdateReference) => {
  const api = fetchClusterDb(body.appId, body.appKey, body.dbId, body.dbKey);

  try {
    const { data } = await api.put(API_PATHS.reference + '/' + id, {
      tag: body.tag,
      originalData: body.originalData,
      age: body.age,
      gender: body.gender || null,
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteReference = async (id: string, header: IHeader) => {
  const api = fetchClusterDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.delete(API_PATHS.reference + '/' + id);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getVisits = async (query: IVisitQuery, header: IHeader) => {
  const api = fetchClusterDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  const searchQuery: Record<string, string> = {};
  if (query.startTime) searchQuery['startTime'] = query.startTime;
  if (query.endTime) searchQuery['endTime'] = query.endTime;
  if (query.referenceId) searchQuery['referenceId'] = query.referenceId;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.visit + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getShots = async (query: IVisitQuery, header: IHeader) => {
  const api = fetchClusterDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  const searchQuery: Record<string, string> = {};
  if (query.startTime) searchQuery['filters[startTime]'] = query.startTime;
  if (query.endTime) searchQuery['filters[endTime]'] = query.endTime;
  if (query.referenceId)
    searchQuery['filters[referenceId]'] = query.referenceId;

  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.face + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export interface ISystemErrorResponse {
  response_message?: string;
  response_code?: string;
}

export type FetchErrorData = AxiosError<ISystemErrorResponse>;

export {
  getDatabases,
  getReferences,
  getUser,
  postAuthLogin,
  postLogin,
  postSettingDb,
};
